import ExpandToggler from './components/ExpandToggler';

function init() {
  initToggler();
  window.jQuery && window.jQuery(document).on('wdShopPageInit', initToggler);
}

function initToggler() {
  ExpandToggler.init({
    parentSelector: '.jpCatWidget__item',
    toggleSelector: '.jpCatWidget__expandToggle',
    targetSelector: '.jpCatWidget__sublistWrap',
    parentExpandedClass: 'jpCatWidget__item--open',
    expandedClass: 'jpCatWidget__sublistWrap--open'
  });
}
  
export default { init };